// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  IconShoppingCart,
  IconBuildingStore,
  IconSettings,
  IconTools,
  IconCalendarEvent,
  IconReceipt2,
  IconCode,
  IconUser,
  IconInfoCircle,
  IconChartBar, 
} from '@tabler/icons';

const other = {
  id: 'menu-items',
  type: 'group',
  children: [
    // {
    //   id: 'products',
    //   title: <FormattedMessage id="Products" />,
    //   type: 'item',
    //   url: '/products',
    //   icon: IconShoppingCart,
    //   breadcrumbs: false,
    // },

    {
      id: 'manufacturers',
      title: <FormattedMessage id="Manufacturers" />,
      type: 'item',
      url: '/manufacturers',
      icon: IconBuildingStore,
      breadcrumbs: false,
    },
    {
      id: 'analytics',
      title: <FormattedMessage id="analytics" />,
      type: 'item',
      url: '/analytics',
      icon: IconChartBar,
      breadcrumbs: false,
    },
    {
      id: 'tool-levels',
      title: <FormattedMessage id="Tool Levels" />,
      type: 'item',
      url: '/tool-levels',
      icon: IconSettings,
      breadcrumbs: false,
    },
    {
      id: 'tools',
      title: <FormattedMessage id="Tools" />,
      type: 'item',
      url: '/tools',
      icon: IconShoppingCart,
      breadcrumbs: false,
    },
    {
      id: 'techniques',
      title: <FormattedMessage id="Techniques" />,
      type: 'item',
      url: '/techniques',
      icon: IconTools,
      breadcrumbs: false,
    },
    {
      id: 'events',
      title: <FormattedMessage id="Events" />,
      type: 'item',
      url: '/events',
      icon: IconCalendarEvent,
      breadcrumbs: false,
    },
    {
      id: 'sponsors',
      title: <FormattedMessage id="Sponsors" />,
      type: 'item',
      url: '/sponsors',
      icon: IconReceipt2,
      breadcrumbs: false,
    },
    {
      id: 'users',
      title: <FormattedMessage id="Users" />,
      type: 'item',
      url: '/users',
      icon: IconUser,
      breadcrumbs: false,
    },
    {
      id: 'about',
      title: <FormattedMessage id="About" />,
      type: 'item',
      url: '/about',
      icon: IconInfoCircle,
      breadcrumbs: false,
    },
  ],
};

export default other;
